// extracted by mini-css-extract-plugin
module.exports = {"fullWindow":"fullWindowModal_fullWindow__3hJ3h","close":"fullWindowModal_close__UOADU","icon":"fullWindowModal_icon__3Yzlv","message":"fullWindowModal_message__2IAGT"};